$.fn.isOnScreen = function () {
    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

$(document).ready(function () {
	//top the top
	$('.tothetop').on('click',function(e){
		e.preventDefault;
		$("body").animate({ scrollTop: 0 });
	});

    // init scroll
    var initScrollCheck = $('.formerror,.afterlogin,.initscroll');
    if (initScrollCheck.length) {
         setTimeout(function () {
             $('html, body').animate({
                 scrollTop: initScrollCheck.offset().top
             }, 1000);
         }, 510);
    }

    // init jump
    var initJumpCheck = $('.initjump');
    if (initJumpCheck.length) {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: initJumpCheck.offset().top
            }, 0);
        }, 510);
    }

    // scrolldown on click
    if ($('.mxm_scrolldown').length) {
        $('.mxm_scrolldown a').on('click', function(event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top
            }, 1000);
        });
    }
});



$("header.main")[0].addEventListener('touchmove', function(event) {
    if($(event.target).closest(".nav-main-content").length > 0){
        return;
    }
    event.preventDefault();
});



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/scroll/init.js
 **/